// roles vs profiles: rol es el papel que despeña,
// perfil es conjunto de permisos
const reviewerRoles = {
    health: 'Especialista de Salud',
    safety: 'Especialista de Seguridad',
    environment: 'Especialista de Medioambiente',
    contractor_hse: 'Asesor SSO Contratista',
    contract_owner: 'Dueño de Contrato',
    administrator: 'Administrador de Contrato',
    hse: 'Asesor SSO',
    owner: 'Dueño de Contrato',
    risk: 'Especialista de Riesgo',
    manager: 'Gerente de Área',
    super: 'Superintendente de Área',
    general_manager: 'Gerente General',
    superadmin: 'Administrador del sistema',
};

const coordinatorRoles = {
    contractor_coordinator: 'Coordinador Contratista',
    coordinator: 'Coordinador',
};

const Roles = Object.assign(
    Object.assign({}, coordinatorRoles),
    reviewerRoles,
);

const contractorRoles = {
    contractor_hse: 'Asesor SSO Contratista',
    contract_owner: 'Dueño de Contrato',
    administrator: 'Administrador de Contrato',
    contractor_coordinator: 'Coordinador Contratista',
};

const bhpProfiles = {
    hse: 'Asesor SSO',
    health: 'Especialista de Salud',
    safety: 'Especialista de Seguridad',
    environment: 'Especialista de Medioambiente',
    contractor_hse: 'Asesor SSO Contratista',
    owner: 'Dueño de Contrato',
    contract_owner: 'Dueño de Contrato',
    risk: 'Especialista de Riesgo',
    administrator: 'Administrador de Contrato',
    contractor_coordinator: 'Coordinador Contratista',
    coordinator: 'Coordinador',
    manager: 'Gerente de Área',
    super: 'Superintendente de Área',
    general_manager: 'Gerente General',
    superadmin: 'Administrador del sistema'
};

export {
    Roles,
    contractorRoles,
    reviewerRoles,
    coordinatorRoles,
    bhpProfiles,
};